import { FailureType } from './app-state.failure.type';
import { AppStateFailure } from './app-state.failure.model';
import { AppStateFailureItemWithErrorCode } from './app-state-errorcode.failure';

export class AppStateFailureBuilder {
  private appStateFailure: AppStateFailure;

  public constructor() {
    const failures = new Array<AppStateFailureItemWithErrorCode>();
    this.appStateFailure = new AppStateFailure(FailureType.General, failures);
  }

  public setFailureType(type: FailureType): AppStateFailureBuilder {
    this.appStateFailure.failureType = type;
    return this;
  }

  public addFailure(
    failure: AppStateFailureItemWithErrorCode
  ): AppStateFailureBuilder {
    this.appStateFailure.failures.push(failure);
    return this;
  }

  public build(): AppStateFailure {
    return this.appStateFailure;
  }
}
